import type { AppTool, ToolRevision } from '../guidance/app-tools/schema'

export function currentSteps(tool: AppTool) {
  return tool.revisions.find(revision => revision.revision === tool.currentRevision)?.steps.actions ?? []
}

export interface SiteMapTool {
  tool: AppTool
  history: Array<{ toolId: string; revision: ToolRevision }>
}

/** Old catalogs may have stored each changed reach plan as a separate tool. */
export function groupSiteMapTools(tools: AppTool[]): SiteMapTool[] {
  const groups = new Map<string, AppTool[]>()
  for (const tool of tools) {
    const key = tool.reachSurfaceId
      ? JSON.stringify(['reach', tool.reachSurfaceId, tool.requiresAuth, [...tool.parameters].sort()])
      : JSON.stringify(['tool', tool.id])
    const group = groups.get(key) ?? []
    group.push(tool)
    groups.set(key, group)
  }
  return [...groups.values()].map(group => {
    const current = (tool: AppTool) => tool.revisions.find(r => r.revision === tool.currentRevision)!
    const ordered = [...group].sort((a, b) => current(b).createdAt.localeCompare(current(a).createdAt) || a.id.localeCompare(b.id))
    const tool = ordered[0]!
    const history = ordered.flatMap(entry => entry.revisions.map(revision => ({ toolId: entry.id, revision })))
      .filter(entry => entry.toolId !== tool.id || entry.revision.revision !== tool.currentRevision)
      .sort((a, b) => b.revision.createdAt.localeCompare(a.revision.createdAt) || b.revision.revision - a.revision.revision)
    return { tool, history }
  })
}

export function siteMapToolTitle(tool: AppTool, surfaceName?: string): string {
  return tool.reachSurfaceId && surfaceName ? `Reach ${surfaceName}` : tool.displayName || tool.description || tool.name
}
